/**
 * CallState represents the authoritative server-side lifecycle state of a call.
 *
 * NEW:
 *   Call object exists but call create transition may not have been applied yet.
 *
 * INVITING:
 *   Server is initiating the call invitation flow.
 *
 * RINGING:
 *   Callee is being notified / ringing. RING timer applies.
 *
 * NEGOTIATING:
 *   Callee accepted; offer/answer + ICE exchange expected. NEGOTIATION timer applies.
 *
 * IN_CALL:
 *   Both peers are considered connected. Media is flowing (via TURN, outside signaling).
 *
 * RECONNECTING:
 *   A peer disconnected mid-call. RECONNECT timer applies.
 *
 * ENDED:
 *   Terminal state; no further signaling should be accepted for this call.
 */
export const CALL_STATE = {
    NEW: "NEW",
    INVITING: "INVITING",
    RINGING: "RINGING",
    NEGOTIATING: "NEGOTIATING",
    IN_CALL: "IN_CALL",
    RECONNECTING: "RECONNECTING",
    ENDED: "ENDED",
};
